import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "src/app/api/api.service";
import { Parametros, Periodo, Result } from "src/app/shared/interfaces";
@Component({
    selector: 'lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.scss'
})
export class ListaComponent implements OnInit {

    private _categoriaId: number = -1;
    private _busqueda: string = "";
    private _periodosActivos: boolean = false;
    private _periodoId: number = -1;
    private _periodosActuales: Periodo[] = [];
    constructor(private route: ActivatedRoute, private api: ApiService) {
    }

    ngOnInit(): void {
        this.obtenerPeriodos();
        this.route.data.subscribe(data => {
            this._periodosActivos = data['periodosActivos'];
        });
    }

    async obtenerPeriodos() {
        try {
            const path = 'periodos';
            let params: Parametros[] = [{ param: 'eliminarPeriodoActual', valor: '1' }];
            const response = (await this.api.consulta(path, false, params, {}, 'GET')).data as Result;
            this._periodosActuales = response.data;
            this.cambioPeriodo(this.ultimoPeriodo);
            console.log("seleccion ultimo Periodo: ", this.ultimoPeriodo);
        } catch (e) {
            console.log(e)
        }
    }

    cambioCategoria(value: number) {
        this._categoriaId = value;
    }

    cambioPeriodo(value: number) {
        this._periodoId = value;
    }

    cambioBusqueda(value: string) {
        this._busqueda = value;
    }

    get categoriaId(): number {
        return this._categoriaId;
    }

    get periodoId(): number {
        return this._periodoId;
    }

    get busqueda(): string {
        return this._busqueda;
    }

    get periodosActivos(): boolean {
        return this._periodosActivos;
    }

    get ultimoPeriodo(): number {
        return this._periodosActuales.length > 0 ? this._periodosActuales[0].id : -1;
    }
}